<template>
    <div>
        <button
            v-if="collapsible"
            type="button"
            class="entity__collapsible"
            :aria-label="trans('SHOW_MORE')"
            @click="toggleCollapse">
            <i
                v-if="collapsed"
                class="fa fa-plus"
                aria-hidden="true"></i>
            <i
                v-else
                class="fa fa-minus"
                aria-hidden="true"></i>
        </button>
        <slot name="trigger"></slot>
        <div :class="collapsedClass">
            <slot name="target"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { searchFormSubmit } from './searchFormSubmit';
    import Translator from 'tools/trans';

    export default Vue.component('SearchEntityGroup', {
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            checked: {
                type: Boolean,
                required: false,
                default: false,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            labelSingleChoice: {
                type: Boolean,
                required: false,
                default: true,
            },
            autoSubmit: {
                type: Boolean,
                required: false,
                default: true,
            },
            collapsible: {
                type: Boolean,
                required: false,
                default: false,
            },
            isCollapsed: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                collapsed: this.isCollapsed,
            };
        },
        computed: {
            isChecked: {
                set(value) {
                    this.setChecked(value);
                    this.setTriggerChecked(value);
                },
                get() {
                    let checkedCount = 0;
                    let checkboxCount = 0;

                    this.$slots.target.forEach(child => {
                        if (child.componentInstance && 'isChecked' in child.componentInstance) {
                            checkboxCount += 1;
                            checkedCount += child.componentInstance.isChecked ? 1 : 0;
                        }
                    });

                    return checkedCount === checkboxCount && checkedCount !== 0;
                },
            },
            collapsedClass() {
                return this.collapsed ? 'hidden' : 'visible';
            },
        },
        watch: {
            singleFilterChecked(checkedFilter) {
                if (checkedFilter === this.entityId) {
                    this.isChecked = true;
                } else if (checkedFilter !== 'MULTI_SELECT') {
                    this.isChecked = false;
                }
            },
            disabled(value) {
                this.setDisabled(value);
            },
            checked(value) {
                this.setChecked(value);
            },
            isChecked() {
                this.$emit('change');
            },
        },
        methods: {
            trans: Translator.trans,
            setTriggerChecked(value) {
                const triggerHtmlElement = this.$slots.trigger[0].elm;
                if (triggerHtmlElement.querySelector("input[type='checkbox']")) {
                    triggerHtmlElement.querySelector("input[type='checkbox']").checked = value;
                }
            },
            setChecked(value) {
                const _this = this; // eslint-disable-line @typescript-eslint/no-this-alias
                if (this.labelSingleChoice) {
                    _this.$store.commit('setSingleFilter', _this.name);
                }
                setTimeout(() => {
                    _this.setChildrenData('isChecked', value);
                    if (_this.autoSubmit) {
                        searchFormSubmit();
                    }
                }, 0);
            },
            setDisabled(value) {
                this.setChildrenData('isDisabled', value);
            },
            setChildrenData(key, value) {
                this.$slots.target.forEach(child => {
                    if (child.componentInstance && key in child.componentInstance) {
                        child.componentInstance[key] = value;
                    }
                });
                this.fireChangeEvent();
            },
            fireChangeEvent() {
                this.$store.dispatch('filterChangeEvent');
            },
            triggerCheckboxInit(checkboxElement) {
                const _this = this; // eslint-disable-line @typescript-eslint/no-this-alias
                checkboxElement.checked = _this.checked;
                checkboxElement.addEventListener('change', event => {
                    _this.setChecked(event.currentTarget.checked);
                });
            },
            toggleCollapse() {
                this.collapsed = !this.collapsed;
            },
        },
        mounted() {
            const _this = this; // eslint-disable-line @typescript-eslint/no-this-alias
            const trigger = this.$slots.trigger[0].elm;
            const triggerCheckbox = trigger.querySelector("input[type='checkbox']");
            if (triggerCheckbox && !this.$slots.trigger[0].componentInstance) {
                this.triggerCheckboxInit(triggerCheckbox);
            } else {
                trigger.addEventListener('click', () => {
                    _this.setChecked(true);
                });
            }
        },
    });
</script>
